import { processEnv } from 'components/configuration/environmentVariables'

export const CDN_BASE_URL = processEnv.REACT_APP_CdnBaseUrl
export const KNOWLEDGEPOINT_SUBPATH = 'knowledgepoint'
export const BPM_SUBPATH = 'bpm'

export const BPM_CDN_URL = `${CDN_BASE_URL}/${BPM_SUBPATH}`
export const KNOWLEDGEPOINT_CDN_URL = `${CDN_BASE_URL}/${KNOWLEDGEPOINT_SUBPATH}`

export const navigateToExternalLink = (link: string) => {
    window.open(link, '_blank')
}
